module.exports = __webpack_public_path__ + "static/img/green_04_342.438679a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/deco/green_04_342.png
// module id = u9x2
// module chunks = 0